'use client'

import PageLayout from '@app/PageLayout/PageLayout'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { OwnerRegistrationForm } from '@pages/OwnerLanding/RegistrationForm/OwnerRegistrationForm'

import type { getOwnerLandingFormPageData } from './getOwnerLandingFormPageData'

const CURRENT_PAGE = 'owner_landing_form'

type OwnerLandingFormPageData = Awaited<ReturnType<typeof getOwnerLandingFormPageData>>

export type OwnerLandingFormPageClientProps = OwnerLandingFormPageData

export default function OwnerLandingFormPageClient({ global_data }: OwnerLandingFormPageClientProps) {
  return (
    <BlockBoundary>
      <PageLayout globalData={global_data} currentPage={CURRENT_PAGE}>
        <OwnerRegistrationForm />
      </PageLayout>
    </BlockBoundary>
  )
}
